import React, { useEffect } from 'react';

import { replaceExternalLinksInHtmlContent } from '~/src/common/components/MarketingModal/utils';
import Seo from '~/src/common/components/Seo';
import Tracker from '~/src/common/services/Tracker';
import { replaceInHTMLContent } from '~/src/common/utils/cloudinary';
import constants from '~/src/constants';
import { GetMarketingBySlugQuery } from '~/src/queries/cms/generated/cms';
import * as S from '~/src/screens/InfoScreen/layout';
import { getInfoImageUrl } from '~/src/screens/InfoScreen/utils';

interface Props {
  slug: string;
  info: NonNullable<NonNullable<GetMarketingBySlugQuery['modaleMarketings']>[number]>;
  source: 'page' | 'modal';
}

const InfoContent = ({ slug, source, info }: Props) => {
  const isPageSource = source === 'page';

  useEffect(() => {
    if (info?.keplr_name) {
      Tracker.sendEvent(source === 'page' ? 'marketing page viewed' : 'marketing modal viewed', {
        'content name': info.keplr_name,
        ...(isPageSource && { 'is page viewed': true }),
      });
    }
  }, [info?.keplr_name, source, isPageSource]);

  const { image, title, description, meta_description: metaDescr, meta_title: metaTitle } = info;
  const imageUrl = getInfoImageUrl(image, isPageSource);
  // transforme les images cloudinary en iod
  const replacedImageContent = replaceInHTMLContent(description || '');

  // transforme les liens externes pour les ouvrir dans un nouvel onglet
  const replacedContent = replaceExternalLinksInHtmlContent(replacedImageContent || '');
  const canonical = `${constants.SITE_URL}/info/${slug}`;
  const Container = isPageSource ? S.PageContent : S.ModalContent;

  return (
    <>
      {isPageSource ? (
        <Seo title={metaTitle || title} metaDescr={metaDescr} canonicalUrl={canonical} noSuffix />
      ) : null}
      <S.Image src={imageUrl} withBorderRadius={!isPageSource} />
      <Container>
        <S.StyledWaves />
        <S.Title>{title}</S.Title>
        <S.TextContent html={replacedContent} className="ck-content" />
      </Container>
    </>
  );
};

export default InfoContent;
